import { AddIcon } from "@chakra-ui/icons";
import {
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  IconButton,
  Tooltip,
  Button,
} from "@chakra-ui/react";
import { NewPathForm } from "features/Path/Components/Form/PathForm";
import React from "react";

interface CreatePathButtonWithModalProps {
  /**
   * "icon"    — ghost icon button with tooltip (original behavior).
   * "primary" — primary labeled button "+ New path" for prominent CTAs.
   */
  variant?: "icon" | "primary";
}

export default function CreatePathButtonWithModal({ variant = "icon" }: CreatePathButtonWithModalProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const initialRef = React.useRef(null);

  return (
    <>
      {variant === "primary" ? (
        <Button
          onClick={onOpen}
          colorScheme="cdsIndigo"
          leftIcon={<AddIcon boxSize={3} />}
          size="md"
        >
          New path
        </Button>
      ) : (
        <Tooltip label="Add New Path">
          <IconButton
            aria-label="Add New Path"
            icon={<AddIcon />}
            onClick={onOpen}
            variant="ghost"
          />
        </Tooltip>
      )}

      <Modal initialFocusRef={initialRef} closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose} size="3xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize={30}>Add New Path</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <NewPathForm onClose={onClose} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
